export class FAuth {
  username: string;
  password: string;
  email: string;
  constructor(){
      this.username="";
      this.password="";
      this.email="";
  }
}


// WEBPACK FOOTER //
// ./src/app/auth/shared/fAuth.ts